// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar {
   align-items: center;
}

.menu > li {
   float: left;
}

.menu > li + li {
   margin-left: 1em;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
   margin-left: 10px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.mat-form-field {
   font-size: 14px;
   width: 100%;
}

.mat-column-select {
   overflow: visible;
}

.mat-column-quota {
   text-align: center;
}

.file-action {
   color: #aaa;
   height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/package-manager/package-list/package-list.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;AACf","sourcesContent":[".toolbar {\n   align-items: center;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n   margin-left: 10px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.mat-form-field {\n   font-size: 14px;\n   width: 100%;\n}\n\n.mat-column-select {\n   overflow: visible;\n}\n\n.mat-column-quota {\n   text-align: center;\n}\n\n.file-action {\n   color: #aaa;\n   height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
